import React from "react";
import { connect } from "react-redux";
import withStyles from '@mui/styles/withStyles';
import { actions as DocumentsActions, selectors as DocumentsSelectors } from "store/modules/documents";
import DocumentTable from "./DocumentTable";
import { tabStyles } from "./styles";
import { rejectedByColumn, rejectReasonColumn } from "../helpers/columns";

class RejectedTab extends React.Component {
    render() {
        const { tableProps } = this.props;

        return (
            <DocumentTable {...tableProps} extraColumns={[rejectedByColumn, rejectReasonColumn]} />
        );
    }
}

const mapState = state => {
    const tableProps = {
        ...DocumentsSelectors.getRejectedPaginationData(state),
        data: DocumentsSelectors.getListData(state, {
            statusframe: "rejected",
            part: "data",
        }),
        pageFilter: DocumentsSelectors.getListData(state, {
            statusframe: "rejected",
            part: "filter",
        }),
        pageSort: DocumentsSelectors.getListData(state, {
            statusframe: "rejected",
            part: "sort",
        }),
    };

    return {
        tableProps,
    };
};

const mapActions = {
    fetchDocuments: DocumentsActions.fetchRejectedDocuments,
    onPageChange: DocumentsActions.fetchRejectedDocuments,
    onSortedChange: DocumentsActions.setRejectedSort,
    onFilteredChange: DocumentsActions.setRejectedFilter,
    onPageSizeChange: DocumentsActions.setRejectedPageSize,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { tableProps } = stateProps;
    const {
        fetchDocuments,
        onPageChange,
        onSortedChange,
        onFilteredChange,
        onPageSizeChange
    } = dispatchProps;
    return {
        ...stateProps,
        ...dispatchProps,
        tableProps: {
            ...tableProps,
            fetchData: fetchDocuments,
            onPageChange,
            onSortedChange,
            onFilteredChange,
            onPageSizeChange
        },
        ...ownProps,
    };
};

export default connect(mapState, mapActions, mergeProps)(withStyles(tabStyles)(RejectedTab));
